import { useHistory } from 'react-router-dom'
import { IGoBackProps } from '../interfaces/actions'

const useBack = () => {
  const history = useHistory()
  const goBack = ({ path, state }: IGoBackProps) => {
    if (path) {
      history.push(path, state)
      return
    }
    history.goBack()
  }

  return goBack
}

export default useBack
